import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceUtils} from "../../../infrastructure/utils/device-utils";
import {ResolutionUtils} from "../../../infrastructure/utils/resolution-utils";
import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {BaseModel} from "../../../infrastructure/models/base-model";
import {ARGS} from "../../../core/bootstrap/args";
import {makeObservable, observable} from 'mobx';

export class KinesisEventModel extends BaseModel {
  level_1: String;
  level_2: String;
  level_3: String;
  level_4: String;
  visitor_id: String;
  visit_id: Number;
  os_type: String;
  os_version: String;
  browser_type: String;
  browser_version: String;
  device_platform_type: String;
  device_brand: String;
  device_model: String;
  event_datetime: String;
  datekey: String;
  orientation: String;
  site_version: String;
  site_build: String;
  ip: String;
  event_seq: Number;
  wifi: Boolean;
  is_user_driven: Boolean;
  lang_id: Number;
  partner_id: Number;
  source: String;
  table: String;
  event_name: String;
  title: String;
  description: String;
  domain: String;
  isSync: Boolean;
  country_id: Number;
  web_type: String;
  widget_type: String;
  show_wizard_ab_test: Boolean;
  @observable sent: Boolean;
  @observable retryCount: Number = 0;
  @observable lastRetryTimestamp: Number = null;
  @observable lastErrorCode: String = null;

  constructor(event: BaseAnalyticsEvent, sequence: Number, deviceUtils: DeviceUtils, resolutionUtils: ResolutionUtils, datetimeUtils: DatetimeUtils) {
    super();

    this.level_1 = event.category;
    this.level_2 = event.action;
    this.level_3 = event.label;
    this.level_4 = event.value;
    this.os_type = deviceUtils.info.os.name;
    this.os_version = deviceUtils.info.os.version;
    this.browser_type = deviceUtils.info.browser.name;
    this.browser_version = deviceUtils.info.browser.version;
    this.device_platform_type = deviceUtils.deviceType;
    this.device_brand = deviceUtils.info.device.vendor;
    this.device_model = deviceUtils.info.device.model;
    this.event_datetime = datetimeUtils.toShortDatetime();
    this.datekey = datetimeUtils.toDateObject().valueOf();
    this.orientation = resolutionUtils.orientation;
    this.site_version = ARGS.VERSION_NUMBER;
    this.site_build = '';
    this.event_seq = sequence;
    this.wifi = false;
    this.source = 'test';
    this.table = '365.public.fact_events';
    this.properties = this.resolveProperties(event.properties);
    this.event_name = this.resolveEventName();
    this.description = this.resolveDescription();
    this.title = this.event_name;
    this.domain = this.domainHostname;
    this.isSync = event.isSync;

    makeObservable(this);
  }

  resolveDescription(): String {
    return `${this.event_datetime}, ${this.browser_type}(${this.browser_version})(${this.device_platform_type}-(${this.orientation})), app-version:${this.site_version}`;
  }

  resolveEventName(): String {
    return [this.level_1, this.level_2, this.level_3, this.level_4].filter(x => x).join('_');
  }

  resolveProperties(props): Object {
    const properties: Object = {};

    if (props) {
      Object.keys(props).forEach((prop: String) => {
        properties[prop.toSnakeCase()] = props[prop];
      });
    }

    return properties;
  }

  get domainHostname(): String {
    try {

      // eslint-disable-next-line no-restricted-globals
      const isInIframe: Boolean = parent !== window;

      // eslint-disable-next-line no-restricted-globals
      const hostname: String = isInIframe ? parent.location.hostname : window.location.hostname;

      return hostname;
    } catch (e) {
      return document.referrer?.replace('https://', '').replace('http://', '').replace('/', '');
    }
  }

  toString(): * {
    return JSON.stringify(this);
  }
}
